<cui-button
  [label]="'Show all' | translate"
  data-cy="show-all.button"
  type="secondary">
</cui-button>
